export default "__VITE_ASSET__y6EPm_06__"